/**
 * F6's "from SQL, ask the model" entry: a brand-new dataset, not a rewrite
 * of an existing one (that is `extendColumnPrompt.ts`'s job). Asks for the
 * same `-- grain:` line every dataset-action prompt in this lane now asks
 * for (00_PLAN.md's D5), so the panel never has to guess a grain from the
 * SQL text.
 */
export function newDatasetPrompt(request: string): string {
  return `Write one BigQuery query for a new LE Lens dataset that several cards can share.

What it should answer: ${request}

Aggregate to the coarsest grain that still answers the request: GROUP BY every non-numeric column you select, and aggregate every numeric one. Do not select raw, ungrouped rows.

When the request is time-bound, filter on the table's partitioning column with the named parameters @start_date and @end_date:

  WHERE DATE(<date column>) >= @start_date AND DATE(<date column>) < @end_date

@end_date is already exclusive. Never write a date literal or a relative window such as CURRENT_DATE() - 90.

Return exactly one fenced sql block containing the query, and run it to check the result before answering. After the block, on its own line, state the columns that make one row of the query unique:

  -- grain: <column, column, ...>

If the request needs something no table you can find carries, do not invent a column or a join. Reply with exactly one line instead:

  -- cannot: <what is missing>`;
}
